const accordionOpenIconStyling =
  'after:absolute after:content-[""] after:mr-6 after:mt-0 after:right-[3px] after:top-6 ' +
  'after:h-[10px] after:w-[10px] after:border-b-2 after:border-r-2 ' +
  'after:rotate-45 after:aria-expanded:rotate-[-135deg] after:duration-300';

export default accordionOpenIconStyling;
